const signUpSchema = [
  { name: "name", title: "نام", type: "text", half: true },
  { name: "family", title: "نام خانوادگی", type: "text", half: true },
  { name: "nationalcode", title: "کدملی", type: "tel" },
  { name: "password", title: "کلمه عبور", type: "password", half: true },
  {
    name: "ConfirmPassword",
    title: "تایید کلمه عبور",
    type: "password",
    half: true,
    shouldSend: false
  },
  { name: "avatar", type: "file" }
];
const loginSchema = [
  {
    name: "mobilenumber",
    title: "شماره موبایل",
    type: "tel",
    icon: "md md-smartphone-iphone"
  },
  {
    name: "password",
    title: "رمز عبور",
    type: "password",
    icon: "md md-lock-open"
  }
];
const AddCustomerInformationSchema = [
  {
    name: "secondPhoneNumber",
    title: "شماره تماس دوم",
    type: "tel",
    half: true,
    autoComplete: "off"
  },
  {
    name: "thirdPhoneNumber",
    title: "شماره تماس سوم",
    type: "tel",
    half: true,
    autoComplete: "off"
  },
  {
    name: "customername",
    title: "نام مشتری",
    type: "text",
    half: true,
    autoComplete: "off"
  },
  {
    name: "customerjob",
    title: "نوع فعالیت",
    type: "text",
    half: true,
    autoComplete: "off"
  },
  {
    name: "state",
    title: "استان را انتخاب کنید",
    type: "select",
    props: {
      isSearchable: false
    }
  },
  {
    name: "city",
    title: "شهر را انتخاب کنید",
    type: "select",
    props: {
      isSearchable: false
    }
  },
  { name: "customeraddres", title: "آدرس", type: "text", autoComplete: "off" },
  { name: "description", title: "توضیحات", type: "text", autoComplete: "off" }
];
export { signUpSchema, loginSchema, AddCustomerInformationSchema };
